module.exports = __webpack_public_path__ + "img/icon_istri.f2068535.svg";